import GitHubCalendar from 'react-github-calendar';

const GitContributions = () => {
    return (
        <div className="m-0 z-50 dark:bg-cDarkBG2/20 dark:text-cDarkText text-gray-800 bg-white/20 backdrop-blur-[5px] border border-white/10 w-full sm:rounded-[28px] rounded-[26px] p-5 flex justify-center">
            <GitHubCalendar
            // theme={'GitHub theme'}
                color={'#26A641'}
                // style={{ backgroundColor: isDarkMode ? '#49495c' : '', }}
                username="zamanshahed"
            />
        </div>
    )
}

export default GitContributions